import { Button, Dialog, MarkdownField } from 'src/components';
import { FormLabel, Grid } from '@material-ui/core';
import { type IQuestion } from 'src/models';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import questionActions from 'src/store/Questions/actions';

interface Props {
	open: boolean;
	handleOpen: () => void;
	question?: IQuestion;
	isNew?: boolean;
	sectionId?: number;
}

function QuestionDialog({
	handleOpen,
	isNew,
	open,
	question,
	sectionId,
}: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const create = (question: IQuestion) =>
		dispatch(questionActions.create(question));
	const update = (question: IQuestion) =>
		dispatch(questionActions.update(question));

	const { handleReset, handleSubmit, setFieldValue, values } = useFormik({
		enableReinitialize: true,
		initialValues: isNew
			? {
					name: '',
					sectionId,
			  }
			: {
					...question,
					name: question?.name,
			  },
		onSubmit: (values) => {
			if (isNew) create(values);
			else update(values);
		},
	});

	function handleSave() {
		handleSubmit();
		// HandleClose();
	}

	function handleClose() {
		handleOpen();
		handleReset({});
	}

	return (
		<Dialog
			actions={
				<Button
					actionType={'save'}
					disabled={values.name?.length === 0}
					onClick={handleSave}
				>
					{isNew ? 'Agregar' : 'Guardar'}
				</Button>
			}
			content={
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<FormLabel> Pregunta </FormLabel>

						<MarkdownField
							onChange={async (value: string) =>
								await setFieldValue('name', value)
							}
							value={values.name}
						/>
					</Grid>
				</Grid>
			}
			handleOpen={handleClose}
			maxWidth={'md'}
			open={open}
			title={`${isNew ? 'Agregar' : 'Editar'} pregunta`}
		/>
	);
}

export default QuestionDialog;
